// Firma canonica de una lista de productos (los campos que viajan en sync-cart).
// Se usa para detectar el eco de nuestro propio sync-cart y romper el loop
// sync-cart -> pedido_actualizado -> setCarrito -> sync-cart que disparaba la
// notificacion "nuevo pedido" (y su sonido) una y otra vez en pedidos 'pendiente'.
export const firmaProductos = (items) =>
  JSON.stringify(
    (items || []).map((p) => ({
      c: p?.codigo || '',
      n: Number(p?.cantidad || 0),
      e: (p?.etiquetas || []).map((x) => (x && x.id) || x).sort().join(','),
      x: Number(p?.etiquetas_extra || 0),
      cb: p?.combo_id || null,
      comp: p?.componentes || null,
    }))
  );
